import React, { Component } from 'react'
import { connect } from 'react-redux'
import propTypes from './prop'
import FormChangePassword from '../../container/form-renew-password'
import ProfileInformation from '../../container/profile'
import { Typography } from '@material-ui/core'
import {
  userUpdateEntityAction,
  userGetSelfAction,
} from '../../reducers/user/action'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
class Profile extends Component {
  /**
   *
   */
  render() {
    const { entity, dispatch, classes } = this.props
    let children = <Typography />

    if (entity != null) {
      children = (
        <div className={classes.page}>
          <div className={classes.content}>
            <ProfileInformation />
            <FormChangePassword dispatch={dispatch} hasHeader={true} />
          </div>
        </div>
      )
    }

    return children
  }

  /**
   *
   */
  componentDidMount() {
    const { dispatch } = this.props

    dispatch(userGetSelfAction())
  }

  /**
   *
   */
  componentWillUnmount() {
    const { dispatch } = this.props

    dispatch(userUpdateEntityAction(null))
  }
}

Profile.propTypes = propTypes

const mapStateToProps = response => ({
  entity: response.user.entity,
})

export default connect(mapStateToProps)(withStyles(styles)(Profile))
